<template>
    <div id="recruiter_new_evaluations" class="flex_content">

        <div id="context_bar">
            <TopbarGoEvalsList />
            <TopBarSteps />
        </div>

        <transition :name="stepAnim">
            <keep-alive exclude="FormStep3">
                <component :is="currentStepComponent" ></component>
            </keep-alive>
        </transition>

    </div>

</template>

<script>
import TopBarSteps from "../components/topbar/topbarSteps"
import TopbarGoEvalsList from "../components/topbar/topbarGoEvalsList"

import FormStep1 from "../components/form/formStep1"
import FormStep2 from "../components/form/formStep2"
import FormStep3 from "../components/form/formStep3"
import FormStep4 from "../components/form/formStep4"
import FormStep5 from "../components/form/formStep5"


export default {
    name: 'EvaluationsNew',
    components: {
        TopBarSteps,
        TopbarGoEvalsList,
        FormStep1,
        FormStep2,
        FormStep3,
        FormStep4,
        FormStep5

    },
    beforeCreate() {
        this.$store.dispatch('EvalStore/initNew')
        this.$store.dispatch('RefStore/indexCats', "saven")
        this.$store.dispatch('RefStore/indexRefs', "saven")
        this.$store.dispatch('RefStore/indexCats', "custom")
        this.$store.dispatch('RefStore/indexRefs', "custom")
        this.$store.dispatch('RefStore/indexCats', "custom_company")
        this.$store.dispatch('RefStore/indexRefs', "custom_company")
    },
    data(){
        return {
            stepAnim: "tab-slide-right"
        }
    },
    computed: {
        currentStepComponent(){
            return this.$store.state.EvalStore.formStepsName[this.$store.state.EvalStore.formCurrentStep]
        }
    },
    watch: {
        currentStepComponent: function(newVal, oldVal){
            const newIndex = this.$store.state.EvalStore.formStepsName.indexOf(newVal)
            const oldIndex = this.$store.state.EvalStore.formStepsName.indexOf(oldVal)
            if(newIndex > oldIndex){
                this.stepAnim = "tab-slide-right"
            }else{
                this.stepAnim = "tab-slide-left"
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#index_eval_content{
    background: $white;
}
.form_material_container{
    max-width: 500px;
    margin: 0 auto;
    .select{
        width: 100%;
        select{
            width: 100%;
        }
    }
}
</style>